import styled from "styled-components";

const Footer = () => (
    <FooterContainer>
        Made with ❤️ by Jenny T. Liang
    </FooterContainer>
);

const FooterContainer = styled.div`
    margin-top: 16px;
    text-align: right;
    font-size: 0.9em;
`

export default Footer;